export default{
    //serverUrl:"http://localhost:5000",
    serverUrl:"https://dhs-teaching.envt.fr:443",
}
